import { LitElement } from 'lit';
import { html, css } from 'lit';
import { Image } from '../../Image/Image';
import '../../Time/Timestamp';
import '../../ReadMark/SingleMark/SingleMark.js';
import '../../ReadMark/BlueReadMark/BlueReadMark.js';
import '../../ReadMark/DoubleMark/DoubleMark.js';
import '../../ReadMark/ClockMark/ClockMark.js';
import { parseMessageWithLink } from '../../../../lib/helpers.js';
import '../../MediaGallery/MediaGallery.js';
import { processTextWithMentions } from '../../../../lib/taguser.js';
import videoPlaceholder from '../../../../assets/images/videoPlaceholder.svg';
import imagePlaceholder from '../../../../assets/images/imagePlaceholder.svg';
import '../../../Components/Loader/Spinner/Spinner.js';
import '../../EmojiReactions/EmojiReactions.js';
import '../../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import '../../../../components/ChatUIComponent/ReactionContainer.js';
import'../../ForwardMessage/ForwardUi.js'

class ImageMessageBubble extends LitElement {
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    imageSrc: { type: String },
    message: { type: String },
    height: { type: String },
    width: { type: String },
    isFullScreen: { type: String },
    time: { type: String },
    isRead: { type: Boolean },
    isSelf: { type: Boolean },
    isPopupOpen: { type: Boolean },
    isDelivered: { type: String },
    textColor: { type: String },
    allAttachments: { type: Array },
    isMediaGalleryOpen: { type: Boolean, state: true },
    onImageClick: { type: Function },
    mentionedUsers: { type: Array },
    totalMedia: { type: Number },
    mediaType: { type: Number },
  loadingMediaGallery: { type: Boolean },
    messageId: { type: String },
    reactions: { type: Object },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup: { type: Boolean },
    showReactionButton: { type: Boolean },
    showEmojiReactions: { type: Boolean },
    userMetaData: { type: Object },
    messageType: { type: Number },
    timeColor: { type: String },
    showReactionOnHover: { type: Boolean },
  };

  constructor() {
    super();
    this.isFullScreen = false;
    this.isPopupOpen = false;
    this.isMediaGalleryOpen = false;
    this.mentionedUsers = [];
    this.totalMedia = 0;
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
    this.showReactionOnHover = true
  }
  static styles = css`

    .image-message-container {
      position:relative;
    }

    .image-container {
      cursor: pointer;
      overflow-hidden;
    }

    .full-screen-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100dvh;
      background-color: rgba(0, 0, 0, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }

    .full-screen-image {
      max-width: 90%;
      max-height: 90%;
      object-fit: cover;
    }
      reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }

    .close-button {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 2rem;
      color: white;
      cursor: pointer;
      background: transparent;
      border: none;
    }

    .message-footer{ 
      display: flex;
      align-items:center;
      justify-content: end;
      gap:3px;
      margin-top:3px;
    }

    .actions {
      position: absolute;
      left: -15px;
      cursor: pointer;
      top: 5px;
    }

    .popup {
      position: absolute;
      top: 0px;
      left: -100px;
      background-color: white;
      border: 1px solid #eef1fa;
      border-radius: 5px;
      padding: 10px;
      box-shadow: 0 2px 10px #eef1fa;
      z-index: 10;
      display: flex;
      flex-items: column;
      align-items: center;
      justify-content: center;
    }

    .popup div {
      cursor: pointer;
    }

    media-gallery {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      z-index: 9999;
      justify-content:center;
   }

    .media-gallery media-gallery {
      max-width: 100%;
      max-height: 100%;
      display:flex;
      flex-direction:column;
   }

    .media-gallery media-gallery img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
   }
      .mediaCount{
    position: absolute;
    bottom: 20%;
    left: 10%;
    padding: 8px 10px;
    border-radius: 10px;
    background-color:rgb(246 246 246 / 69%);
    font-weight: 600;
    }

    .media-gallery media-gallery .close-button {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 2rem;
      color: white;
      cursor: pointer;
      background: transparent;
      border: none;
}
      .spinner-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

    .emoji-slider {
      position: absolute;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
      left: 0;
    }

    .reaction-button {
      position: absolute;
      top: 50%;
      right: -25px;
      transform: translateY(-50%);
      cursor: pointer;
      z-index: 100;
    }

      .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

    .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      cursor: pointer;
      font-size: 20px;
      background: var(--bg-secondary-color);
    }
    `;

  openPopup() {
    this.isPopupOpen = !this.isPopupOpen;
  }
  openFullScreen() {
    this.isFullScreen = true;
  }

  closeFullScreen() {
    this.isFullScreen = false;
  }

  openMediaGallery() {
    this.isMediaGalleryOpen = true;
  }

  closeMediaGallery() {
    this.isMediaGalleryOpen = false;
  }

  handleMentionClick = user => {
    this.dispatchEvent(
      new CustomEvent('tagUserClick', {
        detail: { userId: user?.userId, userName: user?.userName },
        bubbles: true,
        composed: true,
      }),
    );
  };

  handleMouseEnter() {
    if(this.showReactionOnHover) {
    this.showReactionButton = true;
    }
  }

  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }
  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;

      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = e => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');

    const path = e.composedPath();

    if (
      (this.showEmojiReactions && !path.includes(emojiReactions) && !path.includes(messageContainer)) ||
      (this.showConfirmationPopup && !path.includes(reactionContainer) && !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  };
  toggleEmojiReactions() {
    this.showConfirmationPopup = false;

    this.showEmojiReactions = !this.showEmojiReactions;

    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }

  render() {
    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0);

    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;

    return html`
      <div
        @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        class="image-message-container"
        style="padding:${this.padding}; 
          border-width:0px;
          border-color: ${this.borderColor};
          border-style:${this.borderStyle};
          border-radius:${this.borderRadius};
          width:${this.width};
          background-color:${this.bgColor}
         "
      >
        ${this.messageType === 1
          ? html`
              <forward-ui></forward-ui>
            `
          : null}
        ${!this.isSelf && this.showReactionButton
          ? html`
        <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}"  ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"/>
          </svg>
        </div>
      `
          : ''}
        ${this.showConfirmationPopup
          ? html` <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container> `
          : ''}
        ${this.showEmojiReactions
          ? html`
              <emoji-reactions .isOpen="${this.showEmojiReactions}" .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}" .selectedEmojis="${this.reactions}"></emoji-reactions>
            `
          : ''}

        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
          ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" "> +${remainingCount} </span>
              
              `
            : ''}
        </div>
        <div
          class="image-container"
          style=" width:${this.width};
          height:${this.height};"
          @click="${e => {
            this.onImageClick(e);
            this.openMediaGallery();
          }}"
        >
          ${Image({
            src: this.imageSrc,
            alt: 'image',
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            borderRadius: this.borderRadius,
            placeholderImage: this.mediatype === 0 ? imagePlaceholder : videoPlaceholder,
          })}
          ${this.totalMedia > 0 ? html`<span class="mediaCount"> + ${this.totalMedia}</span>` : null}
        </div>
        ${this.message && !this.message.includes('AttachmentMessage:')
          ? html`
              <span style="font-size: 14px; color: ${this.textColor}"> ${processTextWithMentions(this.message, this.mentionedUsers, this.handleMentionClick, this.isSelf)} </span>
            `
          : null}

        <div class="message-footer" style="margin-top: ${this.isSelf ? '0' : '4px'};">
          <timestamp-element .time="${this.time || new Date().toISOString()}" .color="${this.timeColor}"></timestamp-element>
          ${this.isSelf
            ? this.isRead == true
              ? html`<blue-read-mark></blue-read-mark>`
              : this.isDelivered == 'true'
                ? html`<double-mark></double-mark>`
                : this.isDelivered == 'pending'
                  ? html`<clock-mark></clock-mark>`
                  : html`<single-mark></single-mark>`
            : null}
        </div>
      </div>
      ${this.isMediaGalleryOpen
        ? html`
            <div class="media-gallery">
              <media-gallery
                .mediaType="${this.allAttachments.flatMap(attachment => attachment.attachments.map(att => att.mimeType))}"
                .images="${this.allAttachments.flatMap(attachment => attachment.attachments.map(att => att.mediaUrl))}"
                .mainImageIndex="${this.allAttachments.flatMap(attachment => attachment.attachments.map(att => att.mediaUrl)).findIndex(mediaUrl => mediaUrl === this.imageSrc)}"
                @close="${this.closeMediaGallery}"
                .allAttachments="${this.allAttachments}"
                .loadingMediaGallery="${this.loadingMediaGallery}"
              ></media-gallery>
            </div>
          `
        : ''}
    `;
  }
}

customElements.define('image-message', ImageMessageBubble);
